import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class TAGZYMEGR extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">TAGZYME GR</h1>
        </header>

        <div className="section">
          <h3>English</h3>
          <ul>
            <li><span className="label">1. Gazette Notification number and Date:</span> S.O.3587 (E) Dated 12-09-2024</li>
            <li><span className="label">2. Title of Biostimulant:</span> (2) Sargassum tenerrimum 2% (Granular)</li>
            <li><span className="label">3. Composition:</span>
              <ul>
                <li>(i) Alginic acid per cent. by weight, minimum: 0.2</li>
                <li>(ii) pH (1:2 aqueous solution): 6.0–8.5</li>
                <li>(iii) Bulk density (g/cc): 0.95 – 1.1</li>
              </ul>
            </li>
            <li><span className="label">4. Crops:</span> Paddy</li>
            <li><span className="label">5. Doses:</span>
              <ul>
                <li>(i) Paddy: One soil application at 12.5 kg/ha</li>
                <li>(ii) Tomato: One soil application at 12.5 kg/ha</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="section">
          <h3>हिन्दी</h3>
          <ul>
            <li><span className="label">1. राजपत्र अधिसूचना संख्या एवं दिनांक:</span> एस.ओ.3587 (ई) दिनांक 12-09-2024</li>
            <li><span className="label">2. जैवउत्तेजक का नाम:</span> (2) सार्गासम टेनेरिमुम 2% (दानेदार)</li>
            <li><span className="label">3. संघटन:</span>
              <ul>
                <li>(i) एल्जिनिक अम्ल प्रतिशत, भार के अनुसार, न्यूनतम: 0.2</li>
                <li>(ii) पीएच (1:2 जलीय घोल): 6.0–8.5</li>
                <li>(iii) थोक घनत्व (ग्राम/सीसी): 0.95 – 1.1</li>
              </ul>
            </li>
            <li><span className="label">4. फसल:</span> धान</li>
            <li><span className="label">5. मात्रा:</span>
              <ul>
                <li>(i) धान: 12.5 किग्रा/हेक्टेयर की दर से एक बार मिट्टी में प्रयोग</li>
                <li>(ii) टमाटर: 12.5 किग्रा/हेक्टेयर की दर से एक बार मिट्टी में प्रयोग</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="section">
          <h3>मराठी</h3>
          <ul>
            <li><span className="label">१. राजपत्र अधिसूचना क्रमांक आणि तारीख:</span> S.O.3587 (E) दिनांक १२-०९-२०२४</li>
            <li><span className="label">२. बायोस्टिम्युलंटचे शीर्षक:</span> (२) सारगॅसम टेनेरिमम २% (ग्रॅन्युलर)</li>
            <li><span className="label">३. रचना:</span>
              <ul>
                <li>(i) वजनानुसार टक्केवारीनुसार अल्जिनिक आम्ल, किमान: ०.२</li>
                <li>(ii) pH (१:२ जलीय द्रावण): ६.०–८.५</li>
                <li>(iii) मोठ्या प्रमाणात घनता (ग्रॅम/सीसी): ०.९५ – १.१</li>
              </ul>
            </li>
            <li><span className="label">४. पीक:</span> भात</li>
            <li><span className="label">५. मात्रा:</span>
              <ul>
                <li>(i) भात: १२.५ किलो/हेक्टर दराने मातीचा एक वापर</li>
                <li>(ii) टोमॅटो: १२.५ किलो/हेक्टर दराने मातीचा एक वापर</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}
